import { useState } from 'react';
import toast from 'react-hot-toast';

import { IconClose } from '../../../common/icons';
import { useModalDialog } from '../../../common/hooks/use-modal-dialog';
import { useCreateManagement, useUpdateManagement } from '../contexts/managements';

import '../styles/billing.css';

// Tipo de manejo/pensión (admin-billing-catalog.md). Su costo se arma en la
// COMPOSICIÓN (líneas) y la TARIFA que liquida vive versionada aparte.
export default function ManagementForm({ management, onClose, onSaved }) {
    const editing = !!management;
    const { mutateAsync: create, isPending: creating } = useCreateManagement();
    const { mutateAsync: update, isPending: updating } = useUpdateManagement(management?.id);
    const busy = creating || updating;
    const cardRef = useModalDialog(onClose);

    const [name, setName] = useState(management?.name || '');
    const [description, setDescription] = useState(management?.description || '');
    const [remarks, setRemarks] = useState(typeof management?.remarks === 'string' ? management.remarks : '');

    const submit = async () => {
        if (!name.trim()) { toast.error('El nombre es obligatorio'); return; }
        const payload = { name: name.trim() };
        if (description.trim()) payload.description = description.trim();
        if (remarks.trim()) payload.remarks = remarks.trim();
        try {
            if (editing) await update(payload); else await create(payload);
            toast.success(editing ? 'Manejo actualizado' : 'Manejo creado');
            onSaved?.();
        } catch (er) {
            if (er?.status === 409) toast.error('Ya existe un manejo activo con ese nombre');
            else if (er?.status !== 403) toast.error(er?.message || 'No se pudo guardar el manejo');
        }
    };

    return (
        <div className="billing-modal" role="dialog" aria-modal="true" aria-label={editing ? 'Editar manejo' : 'Nuevo manejo'}>
            <div className="billing-modal__overlay" onClick={onClose} aria-hidden="true" />
            <div className="billing-modal__card" ref={cardRef}>
                <header className="billing-modal__head">
                    <h2 className="billing-modal__title">{editing ? 'Editar manejo' : 'Nuevo manejo'}</h2>
                    <button type="button" className="billing-modal__close" onClick={onClose} aria-label="Cerrar"><IconClose /></button>
                </header>

                <div className="billing-form">
                    <label className="billing-form__field">
                        <span className="billing-form__label">Nombre</span>
                        <input type="text" maxLength={120} value={name} onChange={(e) => setName(e.target.value)} disabled={busy} />
                    </label>
                    <label className="billing-form__field">
                        <span className="billing-form__label">Descripción</span>
                        <input type="text" maxLength={255} value={description} onChange={(e) => setDescription(e.target.value)} disabled={busy} placeholder="Opcional" />
                    </label>
                    <label className="billing-form__field">
                        <span className="billing-form__label">Notas</span>
                        <textarea rows={2} value={remarks} onChange={(e) => setRemarks(e.target.value)} disabled={busy} placeholder="Opcional" />
                    </label>
                </div>

                <footer className="billing-modal__foot">
                    <button type="button" className="billing-btn billing-btn--ghost" onClick={onClose} disabled={busy}>Cancelar</button>
                    <button type="button" className="billing-btn billing-btn--primary" onClick={submit} disabled={busy}>
                        {busy ? 'Guardando…' : editing ? 'Guardar' : 'Crear'}
                    </button>
                </footer>
            </div>
        </div>
    );
}
